/**
 * OpportunitiesLayout
 * Provides tab navigation between Opportunities and Tracking Profiles.
 * Follows the standardized page design pattern.
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tabs, TabsList, TabsTrigger } from '@mono/ui-components';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
export function OpportunitiesLayout() {
    const location = useLocation();
    const navigate = useNavigate();
    // Determine active tab based on current path
    const activeTab = location.pathname.includes('/tracking-profiles') ? 'tracking-profiles' : 'opportunities';
    const handleTabChange = (value)=>{
        if (value === 'opportunities') {
            navigate('/opportunities');
        } else {
            navigate('/opportunities/tracking-profiles');
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "h-full flex flex-col",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "border-b bg-background",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "pl-14 pr-6 pt-4",
                    children: /*#__PURE__*/ _jsx(Tabs, {
                        value: activeTab,
                        onValueChange: handleTabChange,
                        children: /*#__PURE__*/ _jsxs(TabsList, {
                            className: "h-auto bg-transparent border-0 p-0 gap-8",
                            children: [
                                /*#__PURE__*/ _jsx(TabsTrigger, {
                                    value: "opportunities",
                                    "data-testid": "opportunities-tab",
                                    className: "rounded-none border-b-2 border-transparent px-0 pb-3 font-medium data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=inactive]:text-muted-foreground hover:text-foreground transition-colors",
                                    children: "Opportunities"
                                }),
                                /*#__PURE__*/ _jsx(TabsTrigger, {
                                    value: "tracking-profiles",
                                    "data-testid": "tracking-profiles-tab",
                                    className: "rounded-none border-b-2 border-transparent px-0 pb-3 font-medium data-[state=active]:border-primary data-[state=active]:bg-transparent data-[state=active]:shadow-none data-[state=inactive]:text-muted-foreground hover:text-foreground transition-colors",
                                    children: "Tracking Profiles"
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex-1 overflow-auto",
                children: /*#__PURE__*/ _jsx(Outlet, {})
            })
        ]
    });
}
